module.exports = __webpack_public_path__ + "img/home-bg.10b52d5a.png";